// import authService from '../auth/authService';
import dataLocal from '../helper/shorthand'
import moment from 'moment'

export default {
  install(Vue) {
    Vue.prototype.$dataLocal = dataLocal
    Vue.mixin({
      methods: {
        getSelectValue(val, arr) {
          if (arr.length > 0 && val !== '') {
            let tmp = arr.filter((x) => {
              return x.value == val
            })
            //
            if (tmp.length > 0) {
              return tmp[0]
            }
          }
        },
        getMultivleValue(val, arr) {
          if (arr.length > 0 && val !== '') {
            //
            let tmp = arr.filter((x) => {
              return x.value == val
            })
            //
            if (tmp.length > 0) {
              return tmp[0]
            }
          }
        },
        getDuration(val) {
          let x = new Date(val)
          let now = new Date()
          var timeDiff = now - x
          timeDiff /= 1000

          var seconds = Math.round(timeDiff)
          timeDiff = Math.floor(timeDiff / 60)

          var minutes = Math.round(timeDiff % 60)
          timeDiff = Math.floor(timeDiff / 60)

          var hours = Math.round(timeDiff % 24)
          timeDiff = Math.floor(timeDiff / 24)

          var days = Math.round(timeDiff % 365)
          timeDiff = Math.floor(timeDiff / 365)

          var years = timeDiff

          if (years > 0) {
            return years + (years > 1 ? ' Years ' : ' Year ') + 'ago'
          } else if (days > 0) {
            return days + (days > 1 ? ' Days ' : ' Day ') + 'ago'
          } else if (hours > 0) {
            return hours + (hours > 1 ? ' Hrs ' : ' Hour ') + 'ago'
          } else if (minutes > 0) {
            return minutes + (minutes > 1 ? ' Mins ' : ' Min ') + 'ago'
          } else if (seconds > 0) {
            return seconds + (seconds > 1 ? `sec ago` : 'just now')
          }

          return 'Just Now'
        },
        getDurationV2(val) {
          let x = new Date(val)
          let now = new Date()
          var timeDiff = now - x
          timeDiff /= 1000

          var seconds = Math.round(timeDiff % 60)
          timeDiff = Math.floor(timeDiff / 60)

          var minutes = Math.round(timeDiff % 60)
          timeDiff = Math.floor(timeDiff / 60)

          var hours = Math.round(timeDiff % 24)
          timeDiff = Math.floor(timeDiff / 24)

          var days = Math.round(timeDiff % 365)
          timeDiff = Math.floor(timeDiff / 365)

          var years = timeDiff

          var duration = ''
          if (years > 0) {
            duration += years + 'y '
          }
          if (days > 0) {
            duration += days + 'd '
          }
          if (hours > 0) {
            duration += hours + 'h '
          }
          if (minutes > 0) {
            duration += minutes + 'm '
          }
          if (seconds > 0) {
            duration += seconds + 's '
          }

          if (duration.trim().length === 0) {
            return 'Just Now'
          }

          return duration.trim()
        },
        getSimpleDuration(val) {
          const tmpTime = moment.duration(val)
          if (
            tmpTime.hours() == 0 &&
            tmpTime.minutes() == 0 &&
            tmpTime.seconds() == 0
          ) {
            return `-`
          } else if (tmpTime.hours() == 0 && tmpTime.minutes() == 0) {
            return `${tmpTime.seconds()}s`
          } else if (tmpTime.hours() == 0) {
            return `${tmpTime.minutes()}m ${tmpTime.seconds()}s`
          }
          return `${tmpTime.hours()}h ${tmpTime.minutes()}m ${tmpTime.seconds()}s`
        },
        // the val is in seconds
        getSimpleDurationV2(val) {
          //
          const tmpTime = moment.duration(val, 'seconds')
          if (
            tmpTime.hours() == 0 &&
            tmpTime.minutes() == 0 &&
            tmpTime.seconds() == 0
          ) {
            return `-`
          } else if (tmpTime.hours() == 0 && tmpTime.minutes() == 0) {
            return `${tmpTime.seconds()}s`
          } else if (tmpTime.hours() == 0) {
            return `${tmpTime.minutes()}m ${tmpTime.seconds()}s`
          }
          return `${Math.floor(
            tmpTime.asHours()
          )}h ${tmpTime.minutes()}m ${tmpTime.seconds()}s`
        },
        automateLicensePlate(e, input, strips) {
          if (e.key >= 'a' && e.key <= 'z') {
            if (strips.length == 1) {
              input.value += '-'
              const index = input.value.lastIndexOf('-')
              strips.push(index)
            }
          } else if (e.key == '-') {
            setTimeout(() => {
              const index = input.value.lastIndexOf('-')
              strips.push(index)
            }, 50)
            // }
          } else if (e.key >= '0' && e.key <= '9') {
            if (strips.length == 0) {
              input.value += '-'
              const index = input.value.indexOf('-')
              strips.push(index)
            }
          } else if (e.key == 'Backspace') {
            strips.map((x) => {
              if (input.value.length - 1 == x) {
                strips.pop()
              }
            })
          }
        },
        // automateLicensePlate(e, strips) {
        //   if (/[a-zA-Z]/.test(e[e.length - 1])) {
        //     if (strips.length == 1) {
        //
        //       e.push('-')
        //       const index = e.lastIndexOf('-')
        //       strips.push(index)
        //     }
        //   } else if (e == '-') {
        //     setTimeout(() => {
        //       const index = e.lastIndexOf('-')
        //       strips.push(index)
        //     }, 50)
        //     // }
        //   } else if (/^\d+$/.test(e[e.length - 1])) {
        //     if (strips.length == 0) {
        //
        //       e = e + '-'
        //       const index = e.lastIndexOf('-')
        //
        //       strips.push(index)
        //     }
        //   } else if (e == 'Backspace') {
        //     strips.map((x) => {
        //       if (e.length - 1 == x) {
        //         strips.pop()
        //       }
        //     })
        //   }
        //   //
        // },
      },
    })
  },
}
